import { FieldValidator, PathKind } from "@angular/forms/signals";

export abstract class AddressFieldInfo {
    id: string;
    required: boolean = false;
    label?: string;
    autocomplete: string = 'off';
    showLabel: boolean = true;
    validationFunction: FieldValidator<string, PathKind.Root> = () => null;
}
